import React from "react";
import "./BookCabSection.css";
import sedan from "../../assets/sedan.jpg";
import suv from "../../assets/suv.png";
import luxurycar from "../../assets/luxurycar.png"
import { Link } from "react-router-dom";
const BookCabSection = () => {
  return (
    <div className="tapbookgo-wrapper">
      {/* Header */}
      <div className="tapbookgo-header">
        <h2>
          Tap. <span>Book.</span> Go.
        </h2>
        <Link to="/adventure-cab-view-more">
          {" "}
          <button className="view-more-btn">View More</button>
        </Link>
      </div>

      {/* Cards */}
      <div className="tapbookgo-cards">
        {/* Left Card */}

        <Link
          to="/adventure-traveller-detail-page"
          className="luxury-cab-link"
          state={{
            carData: {
              name: "Sedan",
              type: "City Cab",
              fuel: "Petrol",
              capacity: "4 Passenger",
              image: sedan,
            },
            totalPrice: 1200,
          }}
        >
          <div className="book-car-card book-small-card">
            <div className="price-badge">₹1200</div>
            <img src={sedan} alt="Sedan" />
            <h3>Sedan</h3>
            <p>Comfortable family car</p>
          </div>
        </Link>
        {/* Center Card */}
        <Link
          to="/adventure-traveller-detail-page"
          className="luxury-cab-link"
          state={{
            carData: {
              name: "SUV",
              type: "City Cab",
              fuel: "Diesel",
              capacity: "6 Passenger",
              image: suv,
            },
            totalPrice: 1400,
          }}
        >
          <div className="book-car-card book-large-card">
            <div className="price-badge">₹1400</div>
            <img src={suv} alt="SUV" />
            <h3>SUV</h3>
            <p>Spacious for groups</p>
          </div>
        </Link>
        {/* Right Card */}
        <Link
          to="/adventure-traveller-detail-page"
          className="luxury-cab-link"
          state={{
            carData: {
              name: "Luxury Car",
              type: "Luxury Cab",
              fuel: "Petrol",
              capacity: "4 Passenger",
              image: luxurycar,
            },
            totalPrice: 2000,
          }}
        >
          <div className="book-car-card book-small-card">
            <div className="price-badge">₹2000</div>
            <img src={luxurycar} alt="Luxury Car" />
            <h3>Luxury Car</h3>
            <p>Premium experience</p>
          </div>
        </Link>
      </div>
    </div>
  );
};

export default BookCabSection;
